/**
 * Resolves a relative asset URL to an absolute URL using the API base URL.
 * If the URL is already absolute (starts with http), it is sanitized and returned.
 */
export const resolveAssetUrl = (url: string | undefined): string | undefined => {
    if (!url) return undefined;

    const apiUrl = import.meta.env.VITE_API_URL || '';
    const apiBase = apiUrl ? apiUrl.replace(/\/api\/?$/, '') : window.location.origin;

    let processedUrl = url.trim();

    // Fix localhost SSL and port mismatch (Vite 5173 vs Backend 5048):
    if (processedUrl.includes('localhost') || processedUrl.includes('127.0.0.1')) {
        // Prevent ERR_SSL_PROTOCOL_ERROR on local development
        processedUrl = processedUrl.replace(/^https:\/\//i, 'http://');

        // If the URL mistakenly targets the Vite dev server port 5173 for /media/ paths, redirect to backend
        if (processedUrl.includes(':5173/media/')) {
            processedUrl = processedUrl.replace(/http:\/\/localhost:5173/i, apiBase);
        }
    }

    // If it's already an absolute URL
    if (processedUrl.startsWith('http://') || processedUrl.startsWith('https://')) {
        // Upgrade to https for production domain if needed
        if (processedUrl.includes('mosaik-offenbach.de') && processedUrl.startsWith('http://')) {
            return processedUrl.replace('http://', 'https://');
        }
        return processedUrl;
    }

    // Relative URL: prepend backend apiBase
    const separator = processedUrl.startsWith('/') ? '' : '/';
    return `${apiBase.replace(/\/$/, '')}${separator}${processedUrl}`;
};
